/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Not_SubscribedInputs */

const en_plan_not_subscribed = /** @type {(inputs: Plan_Not_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not subscribed`)
};

const es_plan_not_subscribed = /** @type {(inputs: Plan_Not_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin suscripción`)
};

/**
* | output |
* | --- |
* | "Not subscribed" |
*
* @param {Plan_Not_SubscribedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_not_subscribed = /** @type {((inputs?: Plan_Not_SubscribedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Not_SubscribedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_not_subscribed(inputs)
	return en_plan_not_subscribed(inputs)
});